import type { NonIndexRouteObject } from "react-router-dom";
import CloneErrorBox from "./CloneErrorBox";
import loader from "./loader";
import NewForkRoute from "./NewForkRoute";

export const newForkRoute: NonIndexRouteObject = {
  element: <NewForkRoute />,
  errorElement: <CloneErrorBox />,
  loader,
};
